// extracted by mini-css-extract-plugin
export default {"search":"projects_search__Y6JAl","additionalOptions":"projects_additionalOptions__7N0zh","display-flex":"projects_display-flex__gN7fG","header":"projects_header__n-0y2"};